var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.formatMessage(_vm.message, false)),expression:"formatMessage(message, false)"}],staticClass:"chat-bubble user",style:({ background: _vm.widgetColor, color: _vm.textColor })})
}
var staticRenderFns = []

export { render, staticRenderFns }